// v3.24.0 — Espace Pro : réservations beauté reçues + bouton confirmer.
import { useEffect, useState } from "react";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL || "";

export default function ProBookingsSection() {
  const [bookings, setBookings] = useState([]);
  const token = localStorage.getItem("civ_user_token");

  const load = () => {
    fetch(`${API}/api/v3/beaute/bookings/received`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json())
      .then((d) => { if (d.ok) setBookings(d.bookings); })
      .catch(() => {});
  };
  useEffect(load, []); // eslint-disable-line react-hooks/exhaustive-deps

  const confirm = async (bid) => {
    try {
      const r = await fetch(`${API}/api/v3/beaute/bookings/${bid}/confirm`, {
        method: "POST", headers: { Authorization: `Bearer ${token}` },
      });
      const d = await r.json();
      if (!r.ok || !d.ok) throw new Error(d.error || "erreur");
      toast.success("✅ Réservation confirmée au client");
      load();
    } catch (e) { toast.error(`Impossible de confirmer : ${e?.message || e}`); }
  };

  if (!bookings.length) return null;
  return (
    <section data-testid="pro-bookings-section" style={{ marginTop: 16, padding: 14, borderRadius: 14, background: "rgba(236,72,153,0.06)", border: "1px solid rgba(236,72,153,0.3)" }}>
      <div style={{ fontSize: 12, fontWeight: 800, letterSpacing: 1.2, color: "#F9A8D4", marginBottom: 10 }}>
        📅 RÉSERVATIONS REÇUES · {bookings.length}
      </div>
      {bookings.slice(0, 8).map((b) => (
        <div key={b.booking_id} data-testid={`pro-booking-${b.booking_id}`} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 0", borderBottom: "1px solid rgba(255,255,255,0.07)" }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 12.5, fontWeight: 700, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{b.salon_name}</div>
            <div style={{ fontSize: 10.5, opacity: 0.6 }}>
              {b.user_name || b.user_phone} · {b.day} à {b.slot} · code {String(b.booking_id).slice(-6).toUpperCase()}
            </div>
          </div>
          {b.status === "confirmed_pro" ? (
            <span style={{ fontSize: 10.5, fontWeight: 800, color: "#6EE7B7" }}>✓ Confirmée</span>
          ) : (
            <button
              data-testid={`pro-booking-confirm-${b.booking_id}`}
              onClick={() => confirm(b.booking_id)}
              style={{ padding: "6px 12px", borderRadius: 999, border: "none", cursor: "pointer", background: "linear-gradient(135deg,#EC4899,#DB2777)", color: "#fff", fontWeight: 800, fontSize: 11 }}
            >✓ Confirmer</button>
          )}
        </div>
      ))}
    </section>
  );
}
